import { Injectable } from '@angular/core';
import { CookieAuthService, CookieName } from '@nodeModules/@itero/auth-angular';

@Injectable({
	providedIn: 'root',
})
export class AuthCookiesService {

	constructor(private cookieAuthService: CookieAuthService) { }

	removeAllCookies() {
		this.removeCookie(CookieName.COMPANYID);
		this.removeCookie(CookieName.COMPANYTYPES);
		this.removeCookie(CookieName.REGION);
		this.removeCookie(CookieName.IDENTITYPROVIDER);
		this.removeCookie(CookieName.SESSIONID);
		this.removeCookie(CookieName.ITEROTOKEN);
		this.removeCookie(CookieName.IDTOKEN);
	}

	setCookie(...args: Parameters<typeof this.cookieAuthService.setCookie>) {
		const [name, value, options = this.defaultOptions] = args;

		this.cookieAuthService.setCookie(name, value, options);
	}

	removeCookie(...args: Parameters<typeof this.cookieAuthService.removeCookie>) {
		const [name, options = this.defaultOptions] = args;

		this.cookieAuthService.removeCookie(name, options);
	}

	private get defaultOptions() {
		return { path: '/' };
	}
}



